
import React, { useState } from 'react';
import { Helmet } from "react-helmet-async";
import pattern_16 from '../assets/images/background/pattern-16.png';
import { Link } from 'react-router-dom';
import { sendInquiryEmail } from '../utils/inquiryEmail';
import * as inquiry from './inquirySubmission';
import CountryCodeSelector from './CountryCodeSelector';
const isValidEmail = (email) => {
  const v = (email || "").trim();
  if (!v) return true; // email optional
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(v);
};
const digitsOnly = (v) => (v || "").replace(/\D/g, "");

// âœ… letters type hone se rokega
const preventNonNumeric = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
  ];

  // allow ctrl/cmd shortcuts
  if (e.ctrlKey || e.metaKey) return;
  if (allowedKeys.includes(e.key)) return;

  // only digits
  if (!/^\d$/.test(e.key)) e.preventDefault();
};

const Contact = ({ }) => {
	const [formData, setFormData] = useState({ name: '', email: '', countryCode: inquiry.DEFAULT_COUNTRY_CODE, phone: '', subject: '', message: '' });
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState({ success: '', error: '' });

	// Telegram submission kept for future use. Email submission is active now.
	// const botToken = '7869975126:AAETFptfICnYosInsBlMFWlfOpeeGAl_s10';
	// const chatId = '-1002662497260';

	// const handleChange = (e) => {
	// 	setFormData({ ...formData, [e.target.name]: e.target.value });
	// };	
	const handleChange = (e) => {
  const { name, value } = e.target;

  // country change
  if (name === "countryCode") {
    const nextCode = value;
    const rule = inquiry.getCountryPhoneRule(nextCode);

    setFormData((prev) => ({
      ...prev,
      countryCode: nextCode,
      phone: digitsOnly(prev.phone).slice(0, rule.maxDigits),
    }));
    return;
  }

  // phone change (digits only + max)
  if (name === "phone") {
    const code = formData.countryCode || inquiry.DEFAULT_COUNTRY_CODE;
    const rule = inquiry.getCountryPhoneRule(code);

    setFormData((prev) => ({
      ...prev,
      phone: digitsOnly(value).slice(0, rule.maxDigits),
    }));
    return;
  }

  setFormData((prev) => ({ ...prev, [name]: value }));
};


	const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setStatus({ success: "", error: "" });

  const code = formData.countryCode || inquiry.DEFAULT_COUNTRY_CODE;
  const phoneDigits = digitsOnly(formData.phone);

  if (!phoneDigits) {
    setStatus({ success: "", error: "Please enter your mobile number." });
    setLoading(false);
    return;
  }

  if (!inquiry.isValidPhoneNumber(code, phoneDigits)) {
    setStatus({
      success: "",
      error: inquiry.getPhoneValidationMessage(code),
    });
    setLoading(false);
    return;
  }

  if (!formData.message.trim()) {
    setStatus({ success: "", error: "Please enter your message." });
    setLoading(false);
    return;
  }

  if (!isValidEmail(formData.email)) {
    setStatus({ success: "", error: "Please enter a valid email address." });
    setLoading(false);
    return;
  }

  const fullPhone = `${inquiry.getDialCode(code)}${phoneDigits}`;

  try {
    await sendInquiryEmail({
      formName: "SwiftMaze Contact Form",
      name: formData.name,
      email: formData.email,
      phone: fullPhone,
      subject: formData.subject,
      message: formData.message,
    });

    // Telegram submission kept for future use. Email submission is active now.
    // await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ chat_id: chatId, text: msg, parse_mode: 'Markdown' })
    // });

    setStatus({ success: 'Thank you! Your inquiry has been received. We will get back to you shortly.', error: '' });
    setFormData({ name: "", email: "", countryCode: inquiry.DEFAULT_COUNTRY_CODE, phone: "", subject: "", message: "" });
  } catch (err) {
    console.error('Error sending inquiry email:', err);
    setStatus({ success: '', error: 'Something went wrong. Please check your internet connection and try again later.' });
  }

  setLoading(false);
};

	const canonical = "https://www.swiftmazetech.com/contact/";
	const ogImage = "https://www.swiftmazetech.com/assets/images/main-slider/image-2.jpg";
	const description = "Get in touch with SwiftMaze Tech for web development, software solutions, ERP, CRM and digital marketing services. Contact our team for expert guidance.";

	return (
		<>
			<Helmet>
				<title>Contact SwiftMaze Tech | Talk to Our IT & Software Experts</title>
				<meta name="description" content={description} />
				<meta name="robots" content="index,follow" />
				<link rel="canonical" href={canonical} />
				<meta property="og:title" content="Contact SwiftMaze Tech | Talk to Our IT & Software Experts" />
				<meta property="og:description" content={description} />
				<meta property="og:type" content="website" />
				<meta property="og:image" content={ogImage} />
				<meta property="og:url" content={canonical} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content="Contact SwiftMaze Tech | Talk to Our IT & Software Experts" />
				<meta name="twitter:description" content={description} />
				<meta name="twitter:image" content={ogImage} />
			</Helmet>
			<section class="page-title">
				<div class="pattern-layer-one" style={{ backgroundImage: `url(${pattern_16})` }}></div>
				<div class="auto-container">
					<h2>Contact us</h2>
					<ul class="page-breadcrumb">
						{/* <li><a href="index.html">home</a></li> */}
								<li><Link to="/">home</Link></li>
						<li>Contact us</li>
					</ul>
				</div>
			</section>

			<section class="contact-info-section">
				<div class="auto-container">

					<div class="title-box">
						<div class="title">GET IN TOUCH</div>
						<div class="text">For genereal enquires you can touch with our front desk supporting team <br /> at <a href="mailto:swiftmazetech@gmail.com">swiftmazetech@gmail.com</a> or call on <a href="tel:+919978623133">+91 9978623133</a></div>
					</div>
					<div class="row clearfix">
						<div class="info-column col-lg-4 col-md-6 col-sm-12">
							<div class="inner-column">
								<div class="content">
									<div class="icon-box"><span class="flaticon-pin"></span></div>
									<ul>
										<li><strong>Address</strong></li>
										<li>1st floor, Ayesha Complex, College Rd, Next to Dawat Hotel, Modasa, Gujarat 383315</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="info-column col-lg-4 col-md-6 col-sm-12">
							<div class="inner-column">
								<div class="content">
									<div class="icon-box"><span class="flaticon-phone-call"></span></div>
									<ul>
										<li><strong>Phone</strong></li>
										<li>+ 91 99786 23133</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="info-column col-lg-4 col-md-6 col-sm-12">
							<div class="inner-column">
								<div class="content">
									<div class="icon-box"><span class="flaticon-email-1"></span></div>
									<ul>
										<li><strong>E-Mail</strong></li>
										<li>swiftmazetech@gmail.com</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="contact-map-section">
				<div class="auto-container">
					<div class="map-boxed">
						<div class="map-outer">
							<iframe
								title="SwiftMaze Tech Modasa Location"
								src="https://www.google.com/maps?q=SwiftMaze+Tech,+3rd+Floor,+Deluxe+Complex,+College+Road,+Modasa,+Gujarat+383315&z=17&output=embed"
								allowFullScreen=""
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
							></iframe>
						</div>
					</div>
				</div>
			</section>
			<section className="contact-map-section contact-form-section">
				<div class="auto-container">
					<div class="sec-title">
						<div class="clearfix">
							<div class="pull-left">
								<div class="title">SEND YOUR MESSAGE</div>
								<h2>Contact Us</h2>
							</div>
							<div class="pull-right">
								<div class="text">We help businesses grow with smart technology and expert support. <br /> Let&apos;s connect and build success together.</div>
							</div>
						</div>
					</div>
					<div class="contact-form">
						{status.success && (
							<div style={{ backgroundColor: '#e6ffed', border: '1px solid #2ecc71', padding: '10px', borderRadius: '5px', marginBottom: '25px', marginTop: '5px', color: '#2e7d32' }}>
								{status.success}
							</div>
						)}
						{status.error && (
							<div style={{ backgroundColor: '#ffe6e6', border: '1px solid #e74c3c', padding: '10px', borderRadius: '5px', marginBottom: '25px', marginTop: '5px', color: '#c0392b' }}>
								{status.error}
							</div>
						)}
						<form onSubmit={handleSubmit} method="post" action="" id="contact-form">
							<div class="row clearfix">
								<div class="form-group col-lg-6 col-md-6 col-sm-12">
									<label>Your name</label>
									<input type="text" value={formData.name} onChange={handleChange} name="name" placeholder="" />
								</div>
								<div className="form-group col-lg-6 col-md-6 col-sm-12">
									<label>Phone number *</label>

									<div className="contact-form-phone-row">
										<CountryCodeSelector
											value={formData.countryCode}
											onChange={(countryCode) => handleChange({ target: { name: 'countryCode', value: countryCode } })}
										/>

										<input
										type="tel"
										name="phone"
										inputMode="numeric"
										autoComplete="tel"
										placeholder={inquiry.getCountryPhoneRule(formData.countryCode).placeholder}
										value={formData.phone}
										onChange={handleChange}
										onKeyDown={preventNonNumeric}
										maxLength={inquiry.getCountryPhoneRule(formData.countryCode).maxDigits}
										required
										/>
									</div>
								</div>

								<div class="form-group col-lg-6 col-md-6 col-sm-12">
									<label>Email address</label>
									<input type="email" value={formData.email} onChange={handleChange} name="email" placeholder="you@example.com" autoComplete="email" />
								</div>

								<div class="form-group col-lg-6 col-md-6 col-sm-12">
									<label>Subject</label>
									<input type="text" value={formData.subject} onChange={handleChange} name="subject" placeholder="" />
								</div>
								<div class="form-group col-lg-12 col-md-12 col-sm-12">
									<label>Your Message *</label>
									<textarea name="message" value={formData.message} onChange={handleChange} placeholder="" required></textarea>
								</div>
								<div class="form-group text-center col-lg-12 col-md-12 col-sm-12">
									<button class="theme-btn btn-style-three" type="submit" disabled={loading} name="submit-form"><span class="txt">{loading ? 'Sending...' : 'Send Now'}</span></button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</section>
		</>
	);
};
export default Contact;


